'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

var Pin = function () {
	function Pin(model, tooltipSettings) {
		var generalSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		_classCallCheck(this, Pin);

		this.model = model;
		this.map = null;
		this.mouseover = false;
		this.visibilityConditions = {
			tag: true,
			search: true,
			base: !generalSettings.hideInitially
		};

		// Add a utility image object if the pin has an image
		var pinImage = null;
		if (this.model.image.url) {
			pinImage = new Image();
			pinImage.src = this.model.image.url;
		}
		this.image = pinImage;

		// Add a tooltip to the pin
		var tooltip = null;
		if (this.model.tooltipEnabled) {
			tooltip = new MapifyTooltip({
				classes: 'mpfy-tooltip ' + tooltipSettings.classes,
				rgba: tooltipSettings.background,
				content: tooltipSettings.content,
				close_behavior: tooltipSettings.closeBehavior,
				animate: tooltipSettings.animate
			});
		}
		this.tooltip = tooltip;
	}

	_createClass(Pin, [{
		key: 'isVisible',
		value: function isVisible() {
			for (var option in this.visibilityConditions) {
				var condition = this.visibilityConditions[option];

				if (!condition) {
					return false;
				}
			}

			return true;
		}
	}, {
		key: 'setVisibility',
		value: function setVisibility(condition, visible) {
			this.visibilityConditions[condition] = visible;
		}
	}]);

	return Pin;
}();

;

module.exports = Pin;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/pin.js
// module id = 18
// module chunks = 0